import { render, staticRenderFns } from "./width-editor.vue?vue&type=template&id=7bdc5feb&scoped=true&"
import script from "./width-editor.vue?vue&type=script&lang=js&"
export * from "./width-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdc5feb",
  null
  
)

export default component.exports